<p>{{ testimonial }}</p>
<em>&mdash; &nbsp; {{ author }}</em>
